module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"title":"Blog"},"en":{"title":"Blog"},"it":{"title":""},"lt":{"title":"Tinklaraštis"},"pl":{"title":"Blog"}}')
  delete Component.options._Ctor
}
